import { lazy } from 'react';
/** Открывает карточку продукта */
export const ProductDetailsPageAsync = lazy(() => import('./ProductDetails/ProductDetailsPage'));